import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=47593e0e&scoped=true&"
import script from "./reject.vue?vue&type=script&lang=js&"
export * from "./reject.vue?vue&type=script&lang=js&"
import style0 from "./reject.vue?vue&type=style&index=0&id=47593e0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47593e0e",
  null
  
)

export default component.exports